import { useQuery } from "@tanstack/react-query";
import { useCallback, useEffect } from "react";
import { featureIsEnabled } from "../../utils/features.utils";
import { getEnv } from "../../utils/network.utils";
import { getBrambleSdk } from "../client/bramble.sdk";
import { FetchProtocolsQuery } from "../generated/bramble.sdk";

let liveFilledOrdersRef = 0;
let previousFilledOrdersRef = 0;

const STATS_PROTOCOLS_DATA =
  getEnv() === "mainnet"
    ? {
        protocols: [
          {
            blueprint: {
              validators: [
                {
                  hash: "",
                  title: "pool.mint",
                },
              ],
            },
            version: "V3",
          },
          {
            blueprint: {
              validators: [
                {
                  hash: "0029cb7c88c7567b63d1a512c0ed626aa169688ec980730c0473b913",
                  title: "pool.mint",
                },
              ],
            },
            version: "V1",
          },
        ],
      }
    : {
        protocols: [
          {
            blueprint: {
              validators: [
                {
                  hash: "8140c4b89428fc264e90b10c71c53a4c3f9ce52b676bf1d9b51eb9ca",
                  title: "pool.mint",
                },
              ],
            },
            version: "V3",
          },
          {
            blueprint: {
              validators: [
                {
                  hash: "4086577ed57c514f8e29b78f42ef4f379363355a3b65b9a032ee30c9",
                  title: "pool.mint",
                },
              ],
            },
            version: "V1",
          },
        ],
      };

export const useProtocolStats = () => {
  const incrementFilledOrders = useCallback(() => {
    liveFilledOrdersRef += 1;
  }, []);

  const query = useQuery(
    ["protocolStats"],
    async () => {
      const { fetchProtocolStats } = await getBrambleSdk();
      const response = await fetchProtocolStats();

      return response?.stats;
    },
    {
      refetchInterval: 1000 * 5, // 5 seconds
      staleTime: 1000 * 60 * 1, // 1 minute
      cacheTime: 1000 * 60 * 1, // 1 minute
    }
  );

  // Reset the live and new filled order values only when
  // we get new data from the last checkpoint.
  useEffect(() => {
    let newFilledOrders = query.data?.filledOrders || 0;

    if (newFilledOrders > previousFilledOrdersRef) {
      liveFilledOrdersRef = 0;
      previousFilledOrdersRef = newFilledOrders;
    }
  }, [query.data?.filledOrders]);

  return {
    ...query,
    liveFilledOrdersRef,
    incrementFilledOrders,
  };
};

export const useProtocols = () => {
  return useQuery(
    ["fetchProtocols"],
    async () => {
      if (featureIsEnabled("bramble")) {
        const { fetchProtocols } = await getBrambleSdk();
        return fetchProtocols();
      }
      return STATS_PROTOCOLS_DATA as FetchProtocolsQuery;
    },
    {
      staleTime: 1000 * 60,
      cacheTime: 1000 * 60,
    }
  );
};
